// extracted by mini-css-extract-plugin
export default {"container":"MaterialTitleStep_container__d6Y1+","titleLbl":"MaterialTitleStep_titleLbl__NIFuI","descriptionPar":"MaterialTitleStep_descriptionPar__ajWFR"};